import { blockedReturnPath } from "@shared/returnTo";
/** Validate browser-supplied destinations, including encoded redirect tricks. */
export function safeReturnTo(raw: unknown): string {
  if (typeof raw !== "string" || raw.length > 512) return "/home";
  let decoded = raw;
  for (let depth = 0; depth < 8; depth++) {
    if (
      !decoded.startsWith("/") ||
      decoded.startsWith("//") ||
      decoded.includes("\\") ||
      Array.from(decoded).some((char) => char.charCodeAt(0) < 32 || char.charCodeAt(0) === 127)
    )
      return "/home";
    try {
      const url = new URL(decoded, "https://app.invalid");
      if (url.origin !== "https://app.invalid" || url.pathname.startsWith("//")) return "/home";
      if (blockedReturnPath(url.pathname)) return "/home";
      const next = decodeURIComponent(decoded);
      if (next === decoded) return raw;
      decoded = next;
    } catch {
      return "/home";
    }
  }
  return "/home";
}

export function returnToFromLocation(location: { search: string; state: unknown }): string {
  const params = new URLSearchParams(location.search);
  const values = params.getAll("returnTo");
  if (values.length > 1) return "/home";
  return safeReturnTo(
    values.length ? values[0] : (location.state as { from?: unknown } | null)?.from,
  );
}

export function authLink(page: "login" | "register", target: string): string {
  const returnTo = safeReturnTo(target);
  return returnTo === "/home" ? `/${page}` : `/${page}?${new URLSearchParams({ returnTo })}`;
}
